document.addEventListener("DOMContentLoaded", function(){
    let titleBars = document.querySelectorAll('.title-bar');
    // let overlayHeadings = document.querySelectorAll('.overlay__heading');
    if (titleBars) {
        titleBars.forEach(titleBar => {
            let newHeight = titleBar.querySelector('h2').offsetHeight + 12;
            titleBar.style.height = `${newHeight}px`;
        });
    }
    // if (overlayHeadings) {
    //     overlayHeadings.forEach(overlayHeading => {
    //         console.log(overlayHeading.querySelector('h2').offsetHeight);
    //         let newHeight = overlayHeading.querySelector('h2').offsetHeight + 12;
    //         overlayHeading.style.height = `${newHeight}px`;
    //     });
    // }
});